import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TeaserNews from '../../teaser/teaser-news';

class ParagraphDossier extends Component {
  render() {
    const
      sectionClassNames = classNames({
      'paragraph paragraph-dossier': true,
      }),
      {content} = this.props;

    return (
      <section className={sectionClassNames}>

        <div className="flag-left" />
        <div className="flag-right"/>

        {this.props.content.fieldHeading &&
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12">
              <h2>{this.props.content.fieldHeading}</h2>
            </div>
          </div>
        </div>
        }

        <div className="container">
          <div className="row items">
            {content.fieldBeitraegeDossier.map((key, index) => <TeaserNews client={this.props.client} key={index} item={key.entity} />)}
          </div>
        </div>

      </section>
    );
  }
}

ParagraphDossier.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphDossier;
